import * as React from "react";
import { connect } from "react-redux";
import StarRatings from 'react-star-ratings';
import { withRouter, Link } from 'react-router-dom';
import OpenSchedulingError from "./OpenSchedulingError";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { formatPhoneNumber, getFirstName, firstNameFirst } from "../../helpers/formatting";
import Rating, { RatingCount, Stars } from '../common/Rating';
import StatusBanner from '../common/StatusBanner';
import VideoVisitTips from "../dashboard/appointment/VideoVisitTips";
import LaunchVideoMessage from '../common/LaunchVideoMessage';
import StaticHtmlContent from "../common/staticHtmlContent";
import { queryParams } from "../../helpers/formatting";
import * as types from "../../constants/actionTypes";


const DATE_FORMAT = Tools.getDateFormats();

class OpenScheduleConfirmation extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.editAppt = this.editAppt.bind(this);
        this.formatTime = this.formatTime.bind(this);
        this.toggleVideoVisitTipsModal = this.toggleVideoVisitTipsModal.bind(this);
        this.state = { showVideoVisitTipsModal: false };
        this.eCheckinEnabled = false;
    }

    componentDidMount() {
        const { schedule, eCheckInStatusSuccess, scheduleCampaignReferrer } = this.props;
        const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        logUI("MBHWeb.UI.OpenScheduleConfirmation.ComponentDidMount", new Date(), Tools.getURLPath(), scheduleCampaignActivity);

        if (!eCheckInStatusSuccess && this.eCheckinEnabled && schedule) {
            const csnId = _.filter(
                schedule.contactIDs, function (o) {
                    return o.type == "CSN";
                }
            )[0].id;
            if (csnId)
                this.props.getEncryptedCSN(csnId); // Trigger Encrypt API. Only passing csnId and the token is passed at the saga level.
        }
    }

    editAppt(e, tryAgain) {
        // Needs to go back to Appointment Info step
        if (e) { e.preventDefault(); }

        //this.props.resetWizard();

        if (tryAgain) {
            this.props.tryAgain(0);
        }
    }

    editPatientInfo(e, tryAgain) {
        if (e) { e.preventDefault(); }

        if (tryAgain) {
            this.props.tryAgain(1);
        }
    }

    getDayOfWeek(x) {
        //var dt = new Date(x);
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);

        var weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        if (Object.prototype.toString.call(dt) === '[object Date]') {
            var strDay = weekday[dt.getDay()];
            return strDay;
        }
        return "Invalid Date";
    }

    date2str(x) {
        var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);

        try {
            const dayName = dt.getDate();
            let monthName = dt.getMonth() + 1;
            if (monthName < 10)
                monthName = "0" + monthName;

            return `${Tools.getMonthName(monthName.toString())} ${dayName}`;
        }
        catch{ this.editAppt(""); }
    }

    dateFormatStrWithDayName(d) {
        if (!d) return '';
        let dateobj = Tools.getDateStrByFormat(Tools.toJSDate(`${d}T00:00:00`, DATE_FORMAT), "ddd MMM D, YYYY").toUpperCase();
        return dateobj;
    }

    formatTime(s) {
        let parts = s && s.split(":");
        let ret = s;

        if (parts && parts.length >= 2) {
            let h = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let s = parseInt(parts[2]);

            let ispm = h >= 12;
            h = h > 12 ? h - 12 : h;

            ret = `${h.toString()}:${m.toString().padStart(2, '0')} ${ispm ? "PM" : "AM"}`;
        }

        return ret;
    }

    toggleVideoVisitTipsModal() {
        let activityCodeForModal = 'MBHWeb.UI.OpenScheduleConfirmation.VideoVisitTips.Open';
        if (this.state.showVideoVisitTipsModal) {
            activityCodeForModal = 'MBHWeb.UI.OpenScheduleConfirmation.VideoVisitTips.Close';
        }
        logUI(activityCodeForModal, new Date(), Tools.getURLPath());
        this.setState({ showVideoVisitTipsModal: !this.state.showVideoVisitTipsModal });
    }

    eCheckInClick = () => {
        //Need to change this to eCheckin route epic.eCheckInStatusSuccess
        const { EncryptedCSN } = this.props;
        let EcheckInRoute = "/appointments";
        if (EncryptedCSN) {
            EcheckInRoute = EncryptedCSN ? { pathname: "/EcheckIn", state: { csnId: EncryptedCSN.CSNHash } } : { pathname: "/appointments" };
        }
        this.props.history.push(EcheckInRoute);
    }

    getTipsBannerMsg = (showBeginEcheckInBanner) => {
        const { currentUser, primaryUser, hasMyChart, scheduleAppointmentForProxy } = this.props;
        const defaultWaitDays = 'a few';
        let tipsMsg = "";

        if (!currentUser || !hasMyChart) {
            tipsMsg = (<span><strong>Please Note:</strong> Your medical records will be available in your account once the care team links them to your account.</span>);
        } else if (hasMyChart) {
            if (!showBeginEcheckInBanner) {
                if (scheduleAppointmentForProxy) {
                    tipsMsg = `Save some time before your visit! eCheck-In will be available on ${currentUser.eid === primaryUser.eid ? `your` : `${getFirstName(currentUser.displayName)}'s`} dashboard ${defaultWaitDays} days prior to ${currentUser.eid === primaryUser.eid ? `your` : `their`} visit.`;
                } else {
                    tipsMsg = `Save some time before your visit! eCheck-In will be available on your dashboard ${defaultWaitDays} days prior to your visit.`;
                }
            }
        }

        return tipsMsg;
    }

    render() {

        const { nonMyChartPatientDetails, providerDetails, scheduleAppointmentForProxy, primaryUser, currentUser, visit, provider, serverData, hasMyChart, enableEcheckinMandatoryUpdates, covid19VaccineVisitTypeId, schedule, providerSearchModel, Covid19VaccineScheduleErrorMsg, isFromCovid19VaccineSchedule, covid19VaccineVisitTypeIdForMinor} = this.props;
        const { eCheckInDays } = serverData || '';

        let findcareSearchParms = null;

        if (providerSearchModel && providerSearchModel.Location) {
            findcareSearchParms = "?" + queryParams({ userlocation: providerSearchModel.Location });
        }

        const { showVideoVisitTipsModal } = this.state;
        //if ((visit.visitType.id === 0 || visit.visitType.id.length === 0) || (visit.department.id === 0 || visit.department.id.length === 0) || visit.date === "" || visit.time === "") {
        //    this.editAppt("");
        //}        
        let patientName = (visit.patient && visit.patient.name) ? visit.patient.name : (primaryUser && primaryUser.displayName ? primaryUser.displayName : "");
        patientName = scheduleAppointmentForProxy ? currentUser ? primaryUser.eid === currentUser.eid ? firstNameFirst(primaryUser.displayName) : firstNameFirst(currentUser.displayName) : patientName : patientName;
        const provPhoto = provider && provider.photoUrl ? provider.photoUrl : '/images/profile-pic.png';
        const providerPhone = providerDetails && providerDetails.consumerCallCenterNumber ? providerDetails.consumerCallCenterNumber : (visit.department.phone ? visit.department.phone : "");
        // let visitTypeDescription = visit.visitType.description.toLowerCase().indexOf("visit") >= 0 ?
        //     visit.visitType.description :
        //     visit.visitType.description + " Visit";
        let visitTypeDescription = this.props.serverData.enableNewProviderSchedulingWorkflow ?   this.props.visitTypeReason :this.props.visitTypeReason?.toLowerCase().indexOf("visit") >= 0 ?
        this.props.visitTypeReason :
        this.props.visitTypeReason + " Visit";

        const visitDirections = visit && visit.department.address ? 'https://www.google.com/maps/place/' + visit.department.address.street1 + ', ' + visit.department.address.city + ', ' + visit.department.address.state + ' ' + visit.department.address.zip : '#';
        const visitDirectionsTarget = visit && visit.department.address ? '_blank' : '_self';
        const videoVisitTypesForLaunchButton = serverData && serverData.videoVisitTypesForLaunchButton ? serverData.videoVisitTypesForLaunchButton : null;
        const isVirtualCareVisit = videoVisitTypesForLaunchButton ? videoVisitTypesForLaunchButton.indexOf(visit.visitType.id) >= 0 ? true : false : false;

        const iscovid19VaccineVisitType = visit && visit.visitType && (visit.visitType.id === covid19VaccineVisitTypeId || visit.visitType.id === covid19VaccineVisitTypeIdForMinor);
        const patientInstruction = iscovid19VaccineVisitType && schedule && schedule.patientInstructions &&
            schedule.patientInstructions.length > 0;

        const covidVaccineDateStr = isFromCovid19VaccineSchedule && schedule && schedule.date ? this.date2str(schedule.date) : '';
        const covidVaccineTimeStr = isFromCovid19VaccineSchedule && schedule && schedule.time ? this.formatTime(schedule.time) : '';
        const covidVaccineDateWithDayName = isFromCovid19VaccineSchedule && schedule && schedule.date ? this.dateFormatStrWithDayName(schedule.date) : '';

        const visitDateTime = iscovid19VaccineVisitType ? (schedule && schedule.date && schedule.time ? new Date(`${schedule.date} ${schedule.time}`) : "") : new Date(`${visit.date} ${visit.time}`);
        const numberOfDaysDiff = Tools.differenceInDays(visitDateTime);
        const timezone = serverData && serverData.showTimeZoneMessage && !Tools.isCentralTimeZone() ? Tools.getCentralDateWithFormat(new Date(), "z") : "";

        const subHeading = (serverData && serverData.videoVisitTypesForDoctorMessage && serverData.videoVisitTypesForDoctorMessage.indexOf(visit.visitType.id) >= 0) ? "You'll receive email confirmation and your doctor will reach out to you about the communication method for your visit." :
            isFromCovid19VaccineSchedule ? `You'll receive email confirmation for ${covidVaccineDateWithDayName} at ${covidVaccineTimeStr}.` : "You will receive an email confirming your appointment.";
        const showBeginEcheckInBanner = !this.props.scheduleAppointmentFailed && hasMyChart && numberOfDaysDiff <= parseInt(eCheckInDays) && enableEcheckinMandatoryUpdates;
        const tipsBannerMsg = this.getTipsBannerMsg(showBeginEcheckInBanner);
        if (showBeginEcheckInBanner)
            this.eCheckinEnabled = true;

        return (
            <div className="schedule-confirmation-container" style={this.props.style}>
                <div className="row">
                    {(this.props.scheduleAppointmentSuccess === true && this.props.scheduleAppointmentFailed !== true) &&
                        <div className="col-12">
                            <StatusBanner
                                bannerMsg="Thanks, you’re all set! We look forward to seeing you."
                                subBannerMsg={subHeading}
                            />
                        </div>
                    }
                    {this.props.scheduleAppointmentFailed === true &&
                        <div className="col-12">
                        <StatusBanner bannerMsg={iscovid19VaccineVisitType && !this.props.createPatientFailed ? <StaticHtmlContent content={Covid19VaccineScheduleErrorMsg} /> : "We were unable to schedule your appointment."} failedStatus>
                                {this.props.createPatientFailed
                                    ? <span>
                                        Please <a href="#" onClick={e => this.editPatientInfo(e, true)}>try again</a> and confirm your information is correct{" "}
                                        {providerPhone && !iscovid19VaccineVisitType && <span>or call <a href={"tel:" + providerPhone} className="phone-link">{providerPhone}</a> to schedule</span>}.
                                      </span>
                                   : iscovid19VaccineVisitType ? 
                                       <span>
                                        <Link to={{ pathname: '/findcare/vaccine', search: findcareSearchParms }} onClick={(e) => { logUI("MBHWeb.UI.OpenScheduleConfirmation.Covid19Vaccine.TryAgain.Clicked", new Date(), Tools.getURLPath()); }}>View other available times and locations.</Link>
                                      </span> :
                                    <span>                                       
                                        Please {providerPhone && <span>call <a href={"tel:" + providerPhone} className="phone-link">{providerPhone}</a> to schedule or </span>}
                                        <a href="#" onClick={e => this.editAppt(e, true)}>try again</a>.
                                     </span>
                                }
                            </StatusBanner>
                        </div>
                    }
                </div>
                <div className={"row" + (this.props.scheduleAppointmentFailed ? " schedule-failure" : "")}>
                    <div className="col-12 confirm-container maxWidth-content">
                        {showBeginEcheckInBanner &&
                            <div className="col-12 echeck-in-container">
                                {isVirtualCareVisit
                                ? <span>eCheck-In is required to launch your video visit</span>
                                : <span>eCheck-In is available to complete</span>}
                            <button className="btn btn-primary" onClick={this.eCheckInClick}>BEGIN ECHECK-IN</button>
                            </div>
                        }
                        <div className="row">
                            <div className="col-12">
                                <div className="row confirm-appt-details-container">
                                    <div className="col-xs-12 col-md-4 confirm-dr-details">
                                        <div className="appt-schedule-for">
                                            <div className="appt-heading"><span>Appointment Scheduled For:</span></div>
                                            <div><span className="visit-time">{patientName}</span></div>
                                            <div>{(nonMyChartPatientDetails && nonMyChartPatientDetails.phoneNumbers && nonMyChartPatientDetails.phoneNumbers[0]) &&
                                                <div className="patient-phone">{formatPhoneNumber(nonMyChartPatientDetails.phoneNumbers[0].number)}</div>}</div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-1 confirm-seperator" />
                                    <div className="col-12 col-md-7 confirm-doctor-addl-details">
                                        <div className="row">
                                            <div className="col-12 col-md-8 confirm-visit-info-container">
                                                {(!isVirtualCareVisit || this.props.scheduleAppointmentFailed) &&
                                                    <div className="confirm-visit-type"> {visitTypeDescription} </div>
                                                }
                                                <div className="item-details">
                                                    <div className="row">
                                                        <div className="col-12 item-name">
                                                            <span>{provider && provider.displayName}</span>
                                                        </div>
                                                    </div>
                                                    {(!isVirtualCareVisit || this.props.scheduleAppointmentFailed) && <div className="row">
                                                        <div className="col-12 item-location">
                                                            <a className={visit && visit.department.address ? "directions-link" : "no-link"} href={visitDirections} target={visitDirectionsTarget}>
                                                                <div className="details-icon-prepend">
                                                                    <div className="icon-col">
                                                                        <span className="icon-address" />
                                                                    </div>
                                                                    <div className="details-col">
                                                                        {visit && visit.department.address && (visit.department.address.street1 || visit.department.address.city) ?
                                                                            <div>
                                                                                {visit.department.address.street1 || visit.department.address.street2 &&
                                                                                    <div>{visit.department.address.street1}{visit.department.address.street2 && <span>, {visit.department.address.street2},</span>} </div>
                                                                                }
                                                                                <div>{visit.department.address.city}, {visit.department.address.state} {visit.department.address.zip} </div>
                                                                            </div>
                                                                            : <div className="no-data-dash">
                                                                                <div />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>}
                                                    <div className="row">
                                                        <div className="col-12 item-phone">
                                                            <a className={providerPhone ? "phone-link" : "no-link"} href={providerPhone ? "tel:" + (providerPhone) : "#"}>
                                                                <div className="details-icon-prepend">
                                                                    <div className="icon-col">
                                                                        <span className="icon-phone" />
                                                                    </div>
                                                                    <div className="details-col">
                                                                        {providerPhone ?
                                                                            <div>{providerPhone}</div>
                                                                            : <div className="no-data-dash">
                                                                                <div />
                                                                            </div>}
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4 text-end visit-date-container">
                                                <div>
                                                    <div className="visit-date">{isFromCovid19VaccineSchedule ? covidVaccineDateStr : this.date2str(visit.date)}</div>
                                                    <div className="visit-time"><span>{isFromCovid19VaccineSchedule ? covidVaccineTimeStr : this.formatTime(visit.time)} {timezone}</span></div>
                                                </div>
                                            </div>
                                            {isVirtualCareVisit &&
                                                <div className="col-12 col-lg-8 launch-video-visit">
                                                    <LaunchVideoMessage numberOfDaysDiff={numberOfDaysDiff} visitDateTime={visitDateTime} logPrefix="MBHWeb.UI.OpenScheduleConfirmation.VideoVisit" />
                                                </div>
                                            }
                                            {(patientInstruction) &&
                                                <div className="col-12 covid-confirmation-container">
                                                    <div className="covid-visit-type">When You Arrive </div>
                                                    <ul className="schedule-patient-instructions">
                                                        {schedule.patientInstructions.map((item, index) => {
                                                            const listClass = item.indexOf("<br>- ") !== -1 ? "list-item-bullet" : "";
                                                            item = item.replace("<br>- ", "");
                                                            return item && <li className={listClass} key={index}><StaticHtmlContent content={item} customAllowedTags={['img']} customAllowedAttributes={{ 'img': ['src'] }}/></li>
                                                        })}
                                                    </ul>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {/* END DOCTOR DETAILS */}

                            </div>
                        </div>
                        <div className="row">
                            {isVirtualCareVisit && <div className="col-12">
                                <div className="tips-banner-container">
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <div className="svg-tips" />
                                        </div>
                                        <div className="details-col">
                                            <div className="tips-text">Be ready! See our helpful tips for a more successful Video Visit.</div>
                                            <button className="btn text-btn" onClick={this.toggleVideoVisitTipsModal}>VIEW TIPS</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {tipsBannerMsg && 
                                <div className="col-12">
                                    <div className="confirmation-status-container status-success">
                                        <div className="row align-items-center">
                                            <div className="col-12">
                                                {tipsBannerMsg}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {window.serverData.data.enableQualtricsSurveyOpenScheduling && <div data-component="OpenScheduleConformation" className="row qtxSurvey"><div className="col-12 maxWidth-content"><div id={this.props.scheduleVisitType==="Video Visit"?"bsw_qtx_video_schedule":"bsw_qtx"} /></div></div>}
                {showVideoVisitTipsModal && <VideoVisitTips showVideoVisitTipsModal={showVideoVisitTipsModal} toggleVideoVisitTipsModal={this.toggleVideoVisitTipsModal} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        schedule: state.openScheduling.schedule,
        enableEcheckinMandatoryUpdates: state.session.serverData && state.session.serverData.enableEcheckinMandatoryUpdates ? state.session.serverData.enableEcheckinMandatoryUpdates : false,
        covid19VaccineVisitTypeId: state.session.serverData && state.session.serverData.covid19VaccineVisitTypeId,
        covid19VaccineVisitTypeIdForMinor: state.session.serverData && state.session.serverData.covid19VaccineVisitTypeIdForMinor,
        Covid19VaccineScheduleErrorMsg: state.session.serverData && state.session.serverData.Covid19VaccineScheduleErrorMsg ? state.session.serverData.Covid19VaccineScheduleErrorMsg : "We're sorry, this appointment is no longer available.",
        EncryptedCSN: state.epic.encryptCSN,
        eCheckInStatusSuccess: state.epic.eCheckInStatusSuccess,
        scheduleVisitType: state.openScheduling && state.openScheduling.schedule && state.openScheduling.schedule.visitType.displayName
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getEncryptedCSN: (csnId) => {
            dispatch({ type: types.GET_EPIC_ENCRYPT_CSN, csnId });
        }
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OpenScheduleConfirmation));